import React from 'react';
import SingleTabSamplePreview from './SingleTabSamplePreview';
import RiskResultsSamplePreview from './RiskResultsSamplePreview';
import BetaEndedCard from './BetaEndedCard';
import { IconLock } from './Icons';
import './BulkRiskCalculator.css';
import './RiskAssessmentProLock.css';

/**
 * Pro gate for the Account Blowout Risk / % Rule Risk single-strategy tab.
 * Mirrors Bulk Risk: blurred preview content + centered upgrade overlay.
 */
function RiskAssessmentProLock({
  riskMode,
  signedIn = false,
  showBetaEndMessage = false,
  onUpgrade,
  onNavigate,
}) {
  const isApex = riskMode === 'apexMae';
  const title = isApex ? '% Rule Risk' : 'Blowout Risk';
  const subtitle = 'This feature is available in RiskLo Pro';
  const description = isApex
    ? 'Upgrade to run consistency / windfall checks with clear GO or NO GO reads, payout-path alignment, and breach probability.'
    : 'Upgrade to get instant GO / NO GO blowout reads with risk score, scaled worst-day loss, and drawdown exceed probability.';

  const overlay = !signedIn ? (
    <div className="pro-lock-overlay">
      <div className="pro-lock-content">
        <div className="pro-lock-icon">
          <IconLock size={48} />
        </div>
        <h3 className="pro-lock-title">{title}</h3>
        <p className="pro-lock-subtitle">Sign in to continue</p>
        <p className="pro-lock-description">
          Sign in to analyze strategy risk with historical GO / NO GO results using RiskLo Pro.
        </p>
        <button
          type="button"
          className="pro-lock-upgrade-button"
          onClick={() => onNavigate && onNavigate('login')}
        >
          Sign in
        </button>
      </div>
    </div>
  ) : (
    <div className="pro-lock-overlay">
      <div className="pro-lock-content">
        <div className="pro-lock-icon">
          <IconLock size={48} />
        </div>
        <h3 className="pro-lock-title">{title}</h3>
        <p className="pro-lock-subtitle">{subtitle}</p>
        <p className="pro-lock-description">{description}</p>
        <button type="button" className="pro-lock-upgrade-button" onClick={onUpgrade}>
          Upgrade to RiskLo Pro
        </button>
      </div>
    </div>
  );

  return (
    <div className="bulk-calculator-locked tab-content risk-assessment-pro-lock">
      {showBetaEndMessage && signedIn ? <BetaEndedCard variant="overlay" /> : overlay}
      <div className="risk-assessment-pro-lock-preview">
        <SingleTabSamplePreview riskMode={riskMode} hideResultsPlaceholder />
        <RiskResultsSamplePreview riskMode={riskMode} />
      </div>
    </div>
  );
}

export default RiskAssessmentProLock;
